import HeadedModal from '@paradigm/design-system/src/components/HeadedModal';

import { useMaybeTrade } from '@paradigm/features/src/unified-rfqs/contexts/unified-trades';
import { Trade } from '@paradigm/features/src/unified-rfqs/entities/shared';
import { GrfqTradeProvider } from '@paradigm/features/src/unified-rfqs/ui/trade-context';
import { TradeDetailsProvider } from '@paradigm/features/src/unified-rfqs/ui/trades/trade-details-context';
import {
  useContextMenuActions,
  useContextMenuView,
} from '../context-menu/context-menu';
import GrfqTradeDetailsModal from '../grfq/trade-recap/TradeRecapModal';
import RfqDetailsModal from '../drfq/rfq-details-bottom-table/RfqDetailsModal';

const MODAL_WIDTH = 750;

export default function TradeDetails() {
  const { detailsItemId: tradeId, isItemDetailsOpen } = useContextMenuView();

  if (!isItemDetailsOpen) return null;

  if (tradeId == null) return <NoTradeFound />;

  return <TradeDetailsModal tradeId={tradeId} />;
}

function TradeDetailsModal({ tradeId }: { tradeId: Trade['id'] }) {
  const trade = useMaybeTrade(tradeId);
  const { isItemDetailsOpen } = useContextMenuView();
  const { closeDetailsModal } = useContextMenuActions();

  if (trade == null) return <NoTradeFound />;

  if (trade.rfqType === 'grfq')
    return (
      <GrfqTradeProvider trade={trade}>
        <TradeDetailsProvider tradeId={trade.id}>
          <GrfqTradeDetailsModal
            isOpen={isItemDetailsOpen}
            close={closeDetailsModal}
          />
        </TradeDetailsProvider>
      </GrfqTradeProvider>
    );

  return <RfqDetailsModal />;
}

function NoTradeFound() {
  const { isItemDetailsOpen } = useContextMenuView();
  const { closeDetailsModal } = useContextMenuActions();
  return (
    <HeadedModal
      title="Trade Recap"
      isOpen={isItemDetailsOpen}
      close={closeDetailsModal}
      width={MODAL_WIDTH}
    >
      <p css="color: red; margin: 2rem; text-align: center">
        Trade not found 😓
      </p>
    </HeadedModal>
  );
}
